import React, { useState } from "react";
import { Accordion, Divider, Header, Icon, Label } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-regular-svg-icons";
import { Segment } from "semantic-ui-react";
import { Report } from "../../crm/reports";

import { useHistory, useParams } from "react-router-dom";
import { DeleteReportsConfirmationModal } from "./deleteReportsConfirmationModal";
import products from "../../../constants/products";

const emailFrequencies = ["Weekly", "Monthly", "Quarterly"];

const scheduledDays = [
  { key: 2, value: "M" },
  { key: 4, value: "T" },
  { key: 8, value: "W" },
  { key: 16, value: "Th" },
  { key: 32, value: "F" },
  { key: 64, value: "Sa" },
  { key: 1, value: "Su" },
];

interface ReportsCardProps {
  reports: Report[];
  title: string;
  canDelete?: boolean;
  product?: string; // Optional prop for product type
}

export const ReportsCard = (props: ReportsCardProps) => {
  const [active, setActive] = useState(true);
  const history = useHistory();

  const params = useParams<{ site: string }>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState<number | undefined>(undefined);

  const hideModal = () => {
    setModalIsOpen(false);
  };

  const openModal = (reportId: number) => {
    setSelectedReportId(reportId);
    setModalIsOpen(true);
  };
  const productName = props.product === products.CRM ? "crm" : "code";

  return (
    <>
      <Segment className='tw-mx-4 tw-my-[8px] tw-p-2'>
        <Accordion className='tw-border-none'>
          <Accordion.Title active={active} onClick={() => setActive((prev) => !prev)}>
            <div className='tw-flex tw-items-center'>
              <Icon name='dropdown' />
              <Header as='h3' className='tw-mt-0'>
                {props.title}
              </Header>
            </div>
          </Accordion.Title>
          <Accordion.Content active={active}>
            {props.reports.map((report: Report, index: number) => (
              <div key={report.reportId}>
                <div key='section' className='tw-flex tw-items-center tw-justify-between '>
                  <div>
                    <div className='tw-flex tw-items-center'>
                      <Header
                        as='h4'
                        color='blue'
                        className='tw-mb-0 tw-cursor-pointer tw-pl-[22px] tw-pr-5'
                        onClick={() => history.push(`/${params.site}/${productName}/reports/${report.reportId}`)}
                        onHover
                      >
                        {report.reportName}
                      </Header>

                      {report.emailFrequency != null && report.emailDay !== null && (
                        <Label className=' tw-rounded-full tw-border-2 tw-border-[#DBDDDE] tw-bg-[white] tw-px-[8px] tw-py-[4px] tw-text-sm tw-text-black'>
                          <FontAwesomeIcon icon={faCalendar} className='tw-mr-2' />
                          {emailFrequencies[report.emailFrequency]}
                          {report.emailFrequency === 0 &&
                            (() => {
                              const days = scheduledDays
                                .filter((day) => report.emailDay !== null && (report.emailDay & day.key) !== 0)
                                .sort((a, b) => a.key - b.key)
                                .map((day) => day.value);

                              return days.length > 0 ? `: ${days.join(", ")}` : null;
                            })()}
                        </Label>
                      )}
                    </div>
                    <p className='tw-mb-0 tw-pl-[22px] tw-text-[14px] tw-text-black tw-text-opacity-70'>
                      {report.description}
                    </p>
                  </div>

                  {props.canDelete && (
                    <Icon
                      name='trash alternate outline'
                      className='tw-ml-auto tw-cursor-pointer'
                      color='black'
                      style={{ opacity: 0.7 }}
                      size='large'
                      onClick={() => openModal(report.reportId)}
                    />
                  )}
                </div>
                {index < props.reports.length - 1 && <Divider className='tw-m-1' />}
              </div>
            ))}
          </Accordion.Content>
        </Accordion>
        <DeleteReportsConfirmationModal open={modalIsOpen} onClose={hideModal} reportId={selectedReportId} />
      </Segment>
    </>
  );
};
